import { env } from "@/env"

const isProductionAdmin = () =>
	typeof window !== "undefined" &&
	window.location.hostname === "admin.cardnexus.com"

export function stripeDashboardUrl(stripeId: string): string {
	const testMode = stripeId.includes("_test_") || !isProductionAdmin()
	const base = testMode
		? "https://dashboard.stripe.com/test"
		: "https://dashboard.stripe.com"
	if (stripeId.startsWith("acct_")) {
		return `${base}/connect/accounts/${stripeId}`
	}
	return `${base}/payments/${stripeId}`
}

export function marketplaceUrl(path: string): string {
	const base = env.VITE_MAIN_APP_URL ?? "http://localhost:4200"
	return `${base.replace(/\/$/, "")}${path}`
}

export function publicProfileUrl(username: string): string {
	return marketplaceUrl(`/users/${username}`)
}

export function buyerPromotionOptInUrl(token: string): string {
	return marketplaceUrl(`/promotions/join/${token}`)
}

export function integrationConnectUrl(slug: string): string {
	return marketplaceUrl(`/connect/${slug}`)
}

export function marketplaceProductUrl(product: {
	gameSlug: string
	expansionSlug: string
	productType: string
	nameSlug: string
	publicId: number
}): string {
	const typeSegment = product.productType === "sealed" ? "sealed" : "card"
	return marketplaceUrl(
		`/explore/${product.gameSlug}/${product.expansionSlug}/${typeSegment}/${product.nameSlug}-${product.publicId}`,
	)
}

export const CM_GAME: Record<string, string> = {
	mtg: "Magic",
	pokemon: "Pokemon",
	"pokemon-japan": "Pokemon",
	ygo: "YuGiOh",
	"ygo-ocg": "YuGiOh",
	onepiece: "OnePiece",
	lorcana: "Lorcana",
	riftbound: "Riftbound",
	fab: "FleshAndBlood",
	swu: "StarWarsUnlimited",
}

export function tcgplayerProductUrl(externalId: number): string {
	return `https://www.tcgplayer.com/product/${externalId}`
}

export function cardmarketProductUrl(
	gameSlug: string,
	externalId: number,
): string | null {
	const segment = CM_GAME[gameSlug]
	if (!segment) return null
	return `https://www.cardmarket.com/en/${segment}/Products?idProduct=${externalId}`
}
